import { CARRIER_INTEGRATIONS_ACTIONS, initialCarrierIntegrationsState } from './carrierIntegrations.types'

/**
 * @param {import('./carrierIntegrations.types').CarrierIntegrationsSlice} state
 * @param {Object} action
 */
export function carrierIntegrationsReducer(state = initialCarrierIntegrationsState, { type, payload }) {
  switch (type) {
    case CARRIER_INTEGRATIONS_ACTIONS.SET_CARRIER_INTEGRATIONS:
      return { ...state, data: payload }

    case CARRIER_INTEGRATIONS_ACTIONS.SET_STATUS:
      return { ...state, status: payload }

    case CARRIER_INTEGRATIONS_ACTIONS.SET_ERRORS:
      return { ...state, errors: [payload, ...state.errors] }

    case CARRIER_INTEGRATIONS_ACTIONS.CLEAR_ERRORS:
      return { ...state, errors: [] }

    default:
      return state
  }
}
